import classNames from 'classnames'
import styles from './index.module.scss'

const ListCardBadge: React.FC = ({ children }) => (
  <div className={classNames(styles.list_card_provider_badge)}>{children}</div>
)

export default ListCardBadge
